import React from "react";
import { useSEO } from "@/hooks/useSEO";
import { CTALink } from "@/components/common/CTALink";
import { SearchX } from "lucide-react";

export default function NotFound() {
  useSEO({ title: "Page Not Found | E Telecom", description: "The page you are looking for could not be found.", path: "/404" });
  return (
    <section className="et-hero-wash relative overflow-hidden">
      <div className="absolute inset-0 et-dot-grid opacity-[0.35]" />
      <div className="et-container relative min-h-[70vh] flex flex-col items-center justify-center text-center py-20">
        <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-white border border-slate-200 shadow-sm text-[var(--et-primary)]"><SearchX className="h-7 w-7" /></span>
        <div className="mt-6 font-display text-6xl font-bold text-slate-900">404</div>
        <h1 className="mt-2 font-display text-2xl font-semibold text-slate-800">Page not found</h1>
        <p className="mt-3 text-slate-600 max-w-md">The page you're looking for doesn't exist or may have moved. Let's get you back on track.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <CTALink to="/" variant="primary" withArrow>Back to Home</CTALink>
          <CTALink to="/contact" variant="secondary">Contact Us</CTALink>
        </div>
      </div>
    </section>
  );
}
